module.exports = __webpack_public_path__ + "img/user-placeholder.395a5381.png";